module.exports = __webpack_public_path__ + "img/no_roooms.03538603.svg";